import { PatchProfileRequestV1, ProfileDTOV1 } from '../swagger-api-v1';

export enum ProfileType {
  STANDARD = 'standard',
  CHILD = 'child'
}

export class Profile {
  constructor(
    public id: number,
    public name: string,
    public numberOfDevices: number,
    public type: ProfileType,
    public internetBlock: boolean,
    public enableTimeTable: boolean,
    public safeSearchEnabled: boolean,
    public isChildProfile: boolean
  ) {}

  public static fromDTO(dto: ProfileDTOV1): Profile {
    return new Profile(
      dto.id,
      dto.name,
      dto.devicesCount,
      dto.childProfile ? ProfileType.CHILD : ProfileType.STANDARD,
      dto.fullLock,
      dto.timetableEnabled,
      dto.safeSearchEnabled,
      dto.childProfile
    );
  }

  public toDTO(): PatchProfileRequestV1 {
    return {
      name: this.name.trim(),
      fullLock: this.internetBlock,
      timetableEnabled: this.enableTimeTable,
      safeSearchEnabled: this.safeSearchEnabled
    };
  }
}
